import { ARTICLE_TYPE, ContentItem, GIF_TYPE, PHOTO_TYPE, STATUS_TYPE, StatusIdea, VIDEO_TYPE } from 'interfaces'
import { TEXT_TYPE } from 'interfaces/Content/ContentType'
import { STOCK_GIF_TYPE, STOCK_PHOTO_TYPE, STOCK_VIDEO_TYPE } from 'interfaces/Content/StockContentTypes'
import { memo, useMemo } from 'react'
import ContentCard, { ContentCardProps } from './ContentCard'
import StatusIdeaCard, { StatusIdeaCardProps } from './StatusIdeaCard'

export type AnyCardProps = ContentCardProps & { children: ContentItem }
  | StatusIdeaCardProps & { children: StatusIdea }

export const AnyCard = memo(function AnyCard(props: AnyCardProps) {
  const item = props.children
  const content = (props as any).content || item as ContentItem

  const shouldRender = useMemo(() => {
    return {
      type: content.type,
      id: content.id
    }
  }, [content.type, content.id])

  const { children, ...cardProps } = props

  switch (shouldRender.type) {
    case PHOTO_TYPE:
    case ARTICLE_TYPE:
    case VIDEO_TYPE:
    case GIF_TYPE:
    case STOCK_PHOTO_TYPE:
    case STOCK_VIDEO_TYPE:
    case STOCK_GIF_TYPE:
    case TEXT_TYPE:
      return (
        <ContentCard
          key={shouldRender.id}
          {...(cardProps as ContentCardProps)}
          content={item as ContentItem}
        />
      )
    case STATUS_TYPE:
      return (
        <StatusIdeaCard
          key={shouldRender.id}
          {...(cardProps as StatusIdeaCardProps)}
          content={item as StatusIdea}
        />
      )

    default:
      console.error('Invalid content type. Need an "AnyContent" child such as a "Photo" or "Article".')
      return null
  }
})

export default AnyCard
